export const GoogleMapApiConfig = 'AIzaSyDjaAV6k8poMWc5sQWSVFI2nH7noZpgUbw';